module.exports = __webpack_public_path__ + "img/AMEX.afb6594f.svg";